import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ContentChildren, ElementRef, Inject, Input, OnDestroy, PLATFORM_ID, QueryList, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { SpOverlayModule } from "./sp-overlay.module";

export class DomHandler {

  public static addClass(element: any, className: string): void {
    if (element && className) {
      if (element.classList) element.classList.add(className);
      else element.className += ' ' + className;
    }
  }
  public static blockBodyScroll(className = 'p-overflow-hidden') {
    document.body.style.setProperty('--scrollbar-width', this.calculateBodyScrollbarWidth() + 'px');
    this.addClass(document.body, className);
  }

  public static calculateBodyScrollbarWidth() {
    return window.innerWidth - document.documentElement.offsetWidth;
  }

  public static unblockBodyScroll(className = 'p-overflow-hidden') {
    document.body.style.removeProperty('--scrollbar-width');
    this.removeClass(document.body, className);
  }

  public static removeClass(element: any, className: string): void {
    if (element && className) {
      if (element.classList) element.classList.remove(className);
      else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }
}

@Component({
  selector: 'sp-overlay',
  template: `
  <div #mask 
            [class]="styleClass"
            [attr.aria-busy]="blocked"
            [ngClass]="{ 'p-blockui-document': !target, 'p-blockui p-component-overlay p-component-overlay-enter': true }"
            [ngStyle]="{ display: 'none' }"
            [attr.data-pc-name]="'blockui'"
            [attr.data-pc-section]="'root'">
    <ng-content></ng-content>
  </div>
  `,
  styleUrl: './sp-overlay.component.css'
})
export class SpOverlayComponent implements AfterViewInit, OnDestroy {
  @Input() target: HTMLElement | undefined;
  @Input() styleClass!: string;
  @Input() get blocked(): boolean {
    return this._blocked;
  }

  set blocked(val: boolean) {
    if (this.mask && this.mask.nativeElement) {
      if (val) this.block();
      else this.unblock();
    } else {
      this._blocked = val;
    }
  }

  _blocked: boolean = false;
  @ViewChild('mask') mask: ElementRef | undefined;
  animationEndListener: VoidFunction | null | undefined;
  contentTemplate: TemplateRef<any> | undefined;

  constructor(@Inject(DOCUMENT) private document: Document, public el: ElementRef, public cd: ChangeDetectorRef, private renderer: Renderer2, @Inject(PLATFORM_ID) public platformId: any) { }

  block() {
    this._blocked = true;
    (this.mask as ElementRef).nativeElement.style.display = 'flex';

    if (this.target) {
      this.target.appendChild((this.mask as ElementRef).nativeElement);
      this.target.style.position = 'relative';
    } else {
      this.renderer.appendChild(this.document.body, (this.mask as ElementRef).nativeElement);
      DomHandler.blockBodyScroll();
    }
  }

  unblock() {
    if (this.mask && !this.animationEndListener) {
      this.animationEndListener = this.renderer.listen(this.mask.nativeElement, 'animationend', this.destroyModal.bind(this));
      DomHandler.addClass(this.mask.nativeElement, 'p-component-overlay-leave');
    }
  }

  destroyModal() {
    this._blocked = false;
    if (this.mask) {
      DomHandler.removeClass(this.mask.nativeElement, 'p-component-overlay-leave');
      this.renderer.removeChild(this.el.nativeElement, this.mask.nativeElement);
      DomHandler.unblockBodyScroll();
    }
    this.unbindAnimationEndListener();
    this.cd.markForCheck();
  }

  unbindAnimationEndListener() {
    if (this.animationEndListener && this.mask) {
      this.animationEndListener();
      this.animationEndListener = null;
    }
  }


  ngAfterViewInit() {
    if (this._blocked) this.block();
  }

  ngAfterContentInit() {

  }

  ngOnDestroy() {
    this.unblock();
    this.destroyModal();
  }


}

@Component({
  selector: 'sp-overlay-container',
  template: `
  <sp-overlay [blocked]="blocked" [target]="overlayContainer" [styleClass]="styleClass">
    @if(loaderTemplate){
      <ng-container *[ngTemplateOutlet]="loaderTemplate"></ng-container>
    }
    @else{
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    }
  </sp-overlay>
  <div #overlayContainer>
    <ng-content></ng-content>
  </div>
  `
})
export class SpOverlayContainerComponent implements AfterViewInit {
  @Input() target: HTMLElement | undefined;
  @Input() styleClass!: string;
  @Input() blocked: boolean = false;

  @ContentChildren(PrimeTemplate) templates: QueryList<PrimeTemplate> | undefined;
  loaderTemplate: TemplateRef<any> | undefined;

  ngAfterViewInit(): void {
    this.mapTemplates();
  }

  mapTemplates() {
    if (this.templates) {
      (this.templates as QueryList<PrimeTemplate>).forEach(item => {
        switch (item.getType()) {
          case 'label':
            this.loaderTemplate = item.template;
            break;
        }
      });
    }
  }
}